import { RouteConfig } from "vue-router";
const BASE_PATH = "views/agriculturalMange";
const agriculturalMange: Array<RouteConfig> = [
  {
    path: "basic-info/agricultural-mange",
    name: "agriculturalMange",
    redirect: { name: "yield" },
    meta: {
      menuMatch: "agriculturalMange",
    },
    component: () => import(`@/${BASE_PATH}/Main.vue`),
    children: [
      {
        path: "yield",
        name: "yield",
        component: () => import(`@/${BASE_PATH}/Yield.vue`),
        meta: {
          index: "5-1",
        },
      },
      {
        path: "process",
        name: "process",
        component: () => import(`@/${BASE_PATH}/process/Process.vue`),
        meta: {
          index: "5-2",
        },
      },
      {
        path: "segment",
        name: "segment",
        component: () => import(`@/${BASE_PATH}/process/Segment.vue`),
        meta: {
          index: "5-2",
        },
      },
      {
        path: "storage",
        name: "storage",
        component: () => import(`@/${BASE_PATH}/Storage.vue`),
        meta: {
          index: "5-3",
        },
      },
    ],
  },
];
export default agriculturalMange;
